export default function reissueQuoteReducer(
    state: any = {
        loading: false,
        done: false,
        error: null,
        response: [],
    },
    action: any) {

    switch (action.type) {

        /**
         *     Get existing locations
         */
        case 'DOWNLOAD_VIEW_QUOTE_PENDING': {
            return { ...state, loading: true }
        }

        case 'DOWNLOAD_VIEW_QUOTE_REJECTED': {
            return { ...state, loading: false, error: action.payload }
        }

        case 'DOWNLOAD_VIEW_QUOTE_FULFILLED': {
            return {
                ...state, loading: false, done: true, error: null, response: action.payload,
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/quote/reissue.ts